import React from 'react';
import AdaptiveText from 'react-adaptive-text';
import {
  IllustratedCheckbox,
  IllustrationRounded,
  Center,
  UseCheckboxProps,
} from '@wegroup/design-system';
import useMobileBreakpoints from '../../../../common/src/hooks/useMobileBreakpoints';
import { manipulateLabel } from '../../utils/riskAnalysisUtils';

interface Props {
  option: { label: string; value: string };
  iconKey?: string;
  isActive?: boolean;
  useCheckboxProps: UseCheckboxProps;
  isDisabled?: boolean;
}

const MultiSelectInputCheckbox: React.FC<React.PropsWithChildren<Props>> = ({
  isActive,
  option,
  iconKey,
  useCheckboxProps,
  isDisabled,
}) => {
  const { label, value } = option;
  const { isTabletS } = useMobileBreakpoints();

  return (
    <Center
      w="100%"
      sx={{
        '> div': {
          maxWidth: { base: '150px', tabletS: '210px' },
        },
      }}
    >
      <IllustratedCheckbox
        Illustration={
          <IllustrationRounded type={iconKey || value} isActive={isActive} />
        }
        key={value}
        useCheckboxProps={useCheckboxProps}
        isDisabled={isDisabled}
      >
        <AdaptiveText
          fontFamily="Circular"
          text={manipulateLabel(label)}
          fontSizeMin={isTabletS ? 14 : 12}
          fontSizeMax={isTabletS ? 20 : 18}
        />
      </IllustratedCheckbox>
    </Center>
  );
};

export default MultiSelectInputCheckbox;
